
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"examEventsAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientExternalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"examId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attendanceExternalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"medicalRequestItemIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"examEventsAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"patientExternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientExternalId"}}},{"kind":"Argument","name":{"kind":"Name","value":"examId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"examId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"attendanceExternalId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attendanceExternalId"}}},{"kind":"Argument","name":{"kind":"Name","value":"medicalRequestItemIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"medicalRequestItemIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"dateTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attendanceCreatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attendanceExternalId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patientExternalId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"patientName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"requesterName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"performerName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"procedureName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operatorName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"finishedValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appraisalSnapshotText"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cidCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cidDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventCreatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventUpdatedAt"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":832}};
    doc.loc.source = {"body":"query examEventsAnalysis(\n  $patientExternalId: String\n  $examId: ID\n  $eventTypes: [String!]\n  $limit: Int\n  $attendanceExternalId: String\n  $medicalRequestItemIds: [ID!]\n  $dateFrom: String\n  $dateTo: String\n) {\n  examEventsAnalysis(\n    patientExternalId: $patientExternalId\n    examId: $examId\n    eventTypes: $eventTypes\n    limit: $limit\n    attendanceExternalId: $attendanceExternalId\n    medicalRequestItemIds: $medicalRequestItemIds\n    dateFrom: $dateFrom\n    dateTo: $dateTo\n  ) {\n    unitName\n    attendanceCreatedAt\n    attendanceExternalId\n    patientExternalId\n    patientName\n    requesterName\n    performerName\n    procedureName\n    operatorName\n    eventType\n    eventDescription\n    finishedValue\n    editReason\n    appraisalSnapshotText\n    cidCode\n    cidDescription\n    eventCreatedAt\n    eventUpdatedAt\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["examEventsAnalysis"] = oneQuery(doc, "examEventsAnalysis");
        
